import React from "react";
import UploadDocuments from "../../components/additionalprofessional/UploadDocuments";
export default function AdditionalProfUploadDocuments() {
  return (
    <>
      <UploadDocuments />
    </>
  );
}
